// Determina la base de la API según el entorno.
// - En el dominio propio / Cloudflare (no-emergent): usa rutas relativas ("") = mismo origen,
//   para llamar a las Cloudflare Pages Functions en /api/*.
// - En preview/producción de Emergent o localhost: usa REACT_APP_BACKEND_URL.
export const API_BASE = (() => {
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    const isEmergent = h.includes('emergent');
    const isLocal = h === 'localhost' || h === '127.0.0.1';
    if (!isEmergent && !isLocal) return '';
  }
  return process.env.REACT_APP_BACKEND_URL || '';
})();
